import React, { ReactNode } from "react";

import { LuPackage, LuShield, LuTrendingUp } from "react-icons/lu";

type AuthLayoutProps = {
  children: ReactNode;
};

const AuthLayout = ({ children }: AuthLayoutProps) => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;

  return (
    <div className="font-inter h-screen w-screen overflow-hidden max-lg:h-auto max-lg:min-h-screen max-lg:w-full max-lg:overflow-visible">
      <div className="flex h-full w-full max-lg:h-auto max-lg:min-h-screen">
        <div className="hidden lg:flex w-1/2 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-[#113F67] via-[#1a4f7a] to-[#34699A]"></div>
          <div className="absolute inset-0 bg-black/10"></div>
          <div className="absolute top-20 left-20 w-32 h-32 bg-white/10 rounded-full blur-xl"></div>
          <div className="absolute bottom-32 right-16 w-24 h-24 bg-white/5 rounded-full blur-lg"></div>
          <div className="absolute top-1/2 left-10 w-16 h-16 bg-white/5 rounded-full blur-md"></div>

          <div className="relative z-10 flex flex-col justify-center items-start p-12 text-white w-full">
            <div className="mb-12">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mr-4">
                  <LuPackage className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h1 className="text-5xl font-bold leading-tight">
                    {companyName}
                  </h1>
                  <p className="text-xl font-light opacity-90 mt-1">
                    Inventory Management
                  </p>
                </div>
              </div>

              <div className="w-20 h-1 bg-white/30 rounded-full mb-8"></div>

              <p className="text-xl leading-relaxed opacity-90 max-w-md mb-12">
                તમારા વ્યવસાયને વ્યવસ્થિત અને કાર્યક્ષમ બનાવવા માટેનું આધુનિક
                અને સંપૂર્ણ સમાધાન
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center mr-4">
                  <LuShield className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold">સુરક્ષિત અને વિશ્વસનીય</h3>
                  <p className="text-sm opacity-80">
                    તમારો ડેટા સંપૂર્ણ સુરક્ષિત
                  </p>
                </div>
              </div>

              <div className="flex items-center">
                <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center mr-4">
                  <LuTrendingUp className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold">રીઅલ-ટાઇમ ટ્રેકિંગ</h3>
                  <p className="text-sm opacity-80">
                    તાત્કાલિક અપડેટ અને રિપોર્ટ
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-1/2 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
          <div className="w-full h-full flex flex-col justify-center px-8 lg:px-16 max-sm:px-4 max-[360px]:px-3 max-lg:h-auto max-lg:py-8 max-sm:py-5">
            <div className="lg:hidden text-center mb-8 max-sm:mb-5">
              <div className="flex items-center justify-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#113F67] to-[#34699A] rounded-xl flex items-center justify-center mr-3">
                  <LuPackage className="w-6 h-6 text-white" />
                </div>
                <div className="text-left">
                  <h1 className="text-2xl font-bold text-[#113F67]">
                    {companyName}
                  </h1>
                  <p className="text-[#34699A] text-sm font-medium">
                    Inventory Management
                  </p>
                </div>
              </div>
            </div>

            {children}

            <div className="text-center mt-8 max-sm:mt-5">
              <p className="text-sm text-gray-500">
                © {new Date().getFullYear()} {companyName}. બધા અધિકારો
                સુરક્ષિત.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AuthLayout;
